import * as React from 'react';
import { Box, Card, Grid, Skeleton, Typography, AspectRatio } from '@mui/joy';

const StyleCardImageSkeleton = () => (
  <AspectRatio ratio="1" sx={{ width: 160, flexShrink: 0 }}>
    <Skeleton variant="overlay" />
  </AspectRatio>
);

const StyleCardTitleSkeleton = () => (
  <Typography level="h4" sx={{ mb: 1 }}>
    <Skeleton variant="rectangular" sx={{ width: '40%', height: '28px' }} />
  </Typography>
);

const StyleCardTagsSkeleton = () => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
    {[...Array(1)].map((_, i) => (
      <Skeleton
        key={i}
        variant="rectangular"
        sx={{
          borderRadius: '16px',
          height: '32px',
          width: '100px',
        }}
      />
    ))}
  </Box>
);

const StyleCardStatsSkeleton = () => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
    {[...Array(4)].map((_, i) => (
      <Box key={i} sx={{ flex: '1 1 220px', minWidth: 220 }}>
        <Card variant="outlined">
          <Typography>
            <Skeleton variant="rectangular" sx={{ width: '100%', height: '20px', mb: 1 }} />
          </Typography>
          <Typography level="h4">
            <Skeleton variant="rectangular" sx={{ width: '60%', height: '20px' }} />
          </Typography>
        </Card>
      </Box>
    ))}
  </Box>
);

const StyleCardSkeleton = () => (
  <Card variant="outlined" sx={{ mb: 3, px: { xs: 2, sm: 4 }, py: { xs: 3, sm: 4 }, width: '100%' }}>
    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
      <StyleCardImageSkeleton />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <StyleCardTitleSkeleton />
        <StyleCardTagsSkeleton />
      </Box>
    </Box>
    <StyleCardStatsSkeleton />
  </Card>
);

export const TrendingSkeleton = () => {
  // CONFIGURATION - Edit these values to change the skeleton
  const NUMBER_OF_STYLE_CARDS = 3;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
      {/* Style Cards Section */}
      <Box sx={{ mb: 0 }}>
        <Grid container spacing={0}>
          {[...Array(NUMBER_OF_STYLE_CARDS)].map((_, index) => (
            <Grid key={index} xs={12}>
              <StyleCardSkeleton />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
